import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RaiseIssue from "./RaiseIssue";
import {
  fetchAllIssuesList
} from "services/redux/fileComplain/action"

import {getRmTicketsFilterDropDown} from "services/redux/maintenance/rmTicket/action";

const mapStateToProps = (state) => ({
    rmTicketFilter: state.rmTicketReducer.rmTicketFilter,
    getAllIssuesListing: state.fileComplainReducer.getAllIssuesListing
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    getRmTicketsFilterDropDown,
    fetchAllIssuesList
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RaiseIssue);
